
import axios from 'axios';

// app config
import AppConfig from 'Constants/AppConfig';
import AuthHeader from 'Constants/AuthHeader';

import { NotificationManager } from 'react-notifications';
import {
   ALL_ACADEMYPROGRAM,
   ACADEMY_PROGRAM_ACTION,
   ADD_ACADEMY_PROGRAM,
   EDIT_ACADEMY_PROGRAM,
   STATUS_ACADEMY_PROGRAM,
   DELETE_ACADEMY_PROGRAM,
   
} from 'Actions/types';

/**
 * Redux Action To Sigin User With Firebase
 */
export const allAcademyProgram = () =>{
    
    
    return (dispatch) => { 
        dispatch({ type: ACADEMY_PROGRAM_ACTION });
        return axios.get(AppConfig.apiurl+'/api/getacademyprogram', { headers: AuthHeader.header })         
        .then(response => {             
            const allroles=response.data.data;
            console.log(allroles)
            dispatch({ type: ALL_ACADEMYPROGRAM, payload: allroles });
        });
    }    

}

export const addAcademyProgram = (name,academy) => async (dispatch) => {
    
    var payload={
        "name":name,
        "academy":academy
     }
     dispatch({ type: ACADEMY_PROGRAM_ACTION });
    return axios.post(AppConfig.apiurl+'/api/addacademyprogram', payload, { headers: AuthHeader.header })
     .then( response => {       
         if(response.status==200){ 
            var resdata=response.data;
            if(resdata.status===1){
               allAcademyProgram()(dispatch);
               NotificationManager.success(resdata.message);               
               dispatch({ type: ADD_ACADEMY_PROGRAM });
            }else{
               NotificationManager.error(resdata.message); 
            }
            return Promise.resolve(resdata);
         }else{
            NotificationManager.error('Academy not added');
         }          
         
     })
     .catch( error => { 
       NotificationManager.error(error);
     });
}


export const editAcademyProgram = (name,id,selectdata) => async (dispatch) => {
    
    var payload={
        "id":id,
        "name":name,
        "academy":selectdata
     }
     dispatch({ type: ACADEMY_PROGRAM_ACTION });
    return axios.post(AppConfig.apiurl+'/api/editacademyprogram', payload, { headers: AuthHeader.header })
     .then( response => {       
         if(response.status==200){ 
            var resdata=response.data;
            if(resdata.status===1){
               allAcademyProgram()(dispatch);
               NotificationManager.success(resdata.message);               
               dispatch({ type: EDIT_ACADEMY_PROGRAM });
            }else{
               NotificationManager.error(resdata.message); 
            }
            return Promise.resolve(resdata);
         }            
         
     })
     .catch( error => { 
       NotificationManager.error(error);
     });
}


export const statusAcademyProgram = (id,status) => async (dispatch) => {
    
    var payload={
        "id":id,
        "status":status
     }
     dispatch({ type: ACADEMY_PROGRAM_ACTION });
    axios.post(AppConfig.apiurl+'/api/statusacademyprogram', payload, { headers: AuthHeader.header })
     .then( response => {       
         if(response.status==200){ 
            var resdata=response.data;
            if(resdata.status===1){
               allAcademyProgram()(dispatch);
               NotificationManager.success(resdata.message);               
               dispatch({ type: STATUS_ACADEMY_PROGRAM });
            }else{
               NotificationManager.error(resdata.message); 
            }
         }            
         
     })
     .catch( error => { 
       NotificationManager.error(error);
     });
}

export const deleteacademyProgram = (id) => async (dispatch) => {
    
    var payload={
        "id":id
     }
     dispatch({ type: ACADEMY_PROGRAM_ACTION });
    axios.post(AppConfig.apiurl+'/api/deleteacademyprogram', payload, { headers: AuthHeader.header })
     .then( response => {       
         if(response.status==200){ 
            var resdata=response.data;
            if(resdata.status===1){
               allAcademyProgram()(dispatch);
               NotificationManager.success(resdata.message);               
               dispatch({ type: DELETE_ACADEMY_PROGRAM });
            }else{
               NotificationManager.error(resdata.message); 
            }
         }            
         
     })
     .catch( error => { 
       NotificationManager.error(error);
     });
}


